'use strict';

var fetch = require('isomorphic-fetch');
var network = require('./network');

var POST_LOGGING_REQUEST = 'POST_LOGGING_REQUEST';
var POST_LOGGING_SUCCESS = 'POST_LOGGING_SUCCESS';
var POST_LOGGING_FAILURE = 'POST_LOGGING_FAILURE';

function postLoggingRequest() {
  return {
    type: POST_LOGGING_REQUEST
  };
}

function postLoggingSuccess() {
  return {
    type: POST_LOGGING_SUCCESS
  };
}

function postLoggingFailure(error) {
  return {
    type: POST_LOGGING_FAILURE,
    payload: {
      status: error.response.status,
      statusText: 'There was an error logging analytics information.'
    }
  };
}

function postLoggingInfo(token, loggingId, collection, data) {
  return function (dispatch) {
    dispatch(postLoggingRequest());
    return fetch('https://oe-log-service.herokuapp.com/api/projects/' + loggingId + '/events/' + collection, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: data
    }).then(network.checkHttpStatus).then(function () {
      return dispatch(postLoggingSuccess());
    }).catch(function (error) {
      dispatch(postLoggingFailure(error));
    });
  };
}

module.exports = {
  POST_LOGGING_REQUEST: POST_LOGGING_REQUEST,
  POST_LOGGING_SUCCESS: POST_LOGGING_SUCCESS,
  POST_LOGGING_FAILURE: POST_LOGGING_FAILURE,
  postLoggingInfo: postLoggingInfo
};